import { createFileRoute, Link, redirect, useNavigate } from '@tanstack/react-router';
import { AuthLayout } from '@/components/AuthLayout';
import { RegisterForm } from '@/features/auth/components/RegisterForm';
import { sessionQueryOptions } from '@/features/auth/api';

export const Route = createFileRoute('/cadastro')({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(sessionQueryOptions()).catch(() => null);
    if (user) throw redirect({ to: '/' });
  },
  component: RegisterPage,
});

function RegisterPage() {
  const navigate = useNavigate();
  return (
    <AuthLayout
      title="Criar conta"
      description="Leva menos de um minuto."
      footer={
        <Link to="/entrar" data-testid="register-goto-login">
          Já tem conta? Entrar
        </Link>
      }
    >
      <RegisterForm onSuccess={() => void navigate({ to: '/' })} />
    </AuthLayout>
  );
}
